import { Divider, Paper } from "@mui/material"
import { DeepReadonly } from "ts-essentials"
import { useCallback } from "react"
import { InstrumentMetadata } from "helpers/types/instruments/metadata"
import { SelectedInstrument } from "helpers/types/instruments/selected"
import BaseSelector from "connected-components/base-selector"
import { IsoDate } from "helpers/types/dates"
import { IDashboardContext } from "../../context/types"
import ModelSelector from "../model-selector"
import DashboardTopBarCompare from "./compare"
import { useAnalytics } from "connected-components/analytics"
import { DASHBOARD_EVENTS } from "../../analytics"

export default function DashboardTopBar({ context, instrumentMetadata, comparisonInstrumentMetadata, baseInstrumentMetadata, adjustedStartDate, onModelChange }: DeepReadonly<DashboardTopBarProps>) {
  const analytics = useAnalytics()

  const onBaseSelected = useCallback((base: SelectedInstrument | null, isDefault: boolean) => {
    if (base) {
      analytics.track(DASHBOARD_EVENTS.BASE_SELECTION, { base, isDefault })
    }
  }, [analytics])

  return <Paper square className="top-selectors">
    <div className="top-selectors-left">
      <BaseSelector context={context} baseInstrumentMetadata={baseInstrumentMetadata} mainInstrumentMetadata={instrumentMetadata} onBaseSelected={onBaseSelected} />
      <Divider orientation="vertical" flexItem />
      <DashboardTopBarCompare context={context} comparisonInstrumentMetadata={comparisonInstrumentMetadata} adjustedStartDate={adjustedStartDate} />
    </div>
    <ModelSelector context={context} onModelChange={onModelChange} />
  </Paper>
}

interface DashboardTopBarProps {
  context: IDashboardContext
  instrumentMetadata: InstrumentMetadata
  comparisonInstrumentMetadata?: InstrumentMetadata
  baseInstrumentMetadata?: InstrumentMetadata
  adjustedStartDate?: IsoDate
  onModelChange?: (modelId: string) => void
}
